import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'idp-input-error',
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputErrorComponent {}
